import React, { useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import Img_logo from "../../assets/auth/logo.png";
import Styles from "../../styles/client/register.module.scss";
import { Link, useNavigate } from "react-router-dom";
import { addClient } from "../../services";
import { clientRoutes } from "../../routers/ClientRouters";
import Swal from "sweetalert2";
import { toast, ToastContainer } from "react-toastify";
import Close_Button from "../../assets/auth/close.png";
import Suceess from "../../assets/auth/success.png";
import { ApiEndpoints } from "../../core";

const Register = () => {
  const navigate = useNavigate();
  const clientnameRef = useRef();
  const clientemailRef = useRef();
  const clientphoneRef = useRef();
  // const clientpasswordRef = useRef();
  const clientdobdayRef = useRef();
  const clientdobmonthRef = useRef();
  const clientdobyearRef = useRef();
  const clientgenderRef = useRef();
  const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);
  const [captchaResponse, setCaptchaResponse] = useState("");
  const reCaptchaRef = useRef(null);

  const handleCaptchaVerify = (response) => {
    setIsCaptchaVerified(!!response);
    setCaptchaResponse(response || "");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const day = clientdobdayRef.current.value;
      const month = clientdobmonthRef.current.value;
      const year = clientdobyearRef.current.value;
      const clientdateofbirth = `${day}/${month}/${year}`;
      const name = clientnameRef.current.value.trim();
      const email = clientemailRef.current.value.trim();
      const phone = clientphoneRef.current.value.trim();
      // const password = clientpasswordRef.current.value.trim();
      const gender = clientgenderRef.current.value;

      // Name validation
      if (!name) {
        toast.error("Name cannot be empty.");
        return;
      }

      // Email validation
      if (!email.includes("@") || !email.includes(".")) {
        toast.error("Email must contain both '@' and '.'");
        return;
      }

      // Password validation

      // if (!password) {
      //   toast.error("Please enter your password");
      //   return;
      // }

      // Phone validation
      if (!phone) {
        toast.error("Phone number cannot be empty.");
        return;
      }

      // Gender validation
      if (!gender) {
        toast.error("Please select your gender.");
        return;
      }

      if (!isCaptchaVerified) {
        toast.error("Please verify that you are not a robot.");
        return;
      }

      // Simple and reliable DOB validation
      const isValidDate = (d, m, y) => {
        const dayNum = Number(d);
        const monthNum = Number(m);
        const yearNum = Number(y);

        // Basic range validation
        if (
          dayNum < 1 ||
          dayNum > 31 ||
          monthNum < 1 ||
          monthNum > 12 ||
          yearNum < 1700
        ) {
          return false;
        }

        // Create date using numeric parameters (no string parsing issues)
        const date = new Date(yearNum, monthNum - 1, dayNum); // monthNum - 1 because months are 0-indexed

        // Check if the date is valid by comparing what we set vs what we got
        return (
          date.getFullYear() === yearNum &&
          date.getMonth() === monthNum - 1 &&
          date.getDate() === dayNum
        );
      };

      if (!isValidDate(Number(day), Number(month), Number(year))) {
        toast.error("Please enter a valid date of birth");
        return;
      }

      const clientdata = {
        name,
        dob: clientdateofbirth,
        email,
        phone,
        // password,
        gender,
        captchaResponse,
      };

      // Submit the data here
      const success = await addClient({ ...clientdata });
      if (success) {
        Swal.fire({
          html: `
            <div style="text-align: center; border-radius: 16px; position: relative; padding: 10px;">
              <button 
                id="customCloseButton" 
                style="position: absolute; top:-10px; right:-15px; background: none; border: none; cursor: pointer;">
                <img 
                  src=${Close_Button} 
                  alt="Close" 
                  style="width: 32px; height: 32px;"
                />
              </button>
        
              <img 
                src=${Suceess} 
                alt="Success" 
                style="width: 90px; margin-bottom: 15px; margin-top: 20px;" 
              />
        
              <h2 style="color:#151515; text-align:center; font-family:gothambold; font-size:16px;">
                Registration <br /> successfully
              </h2>
              <br />
                 <p style="color:#151515; text-align:center; font-family:gotham_bookregular; font-size:12px;">
                We have sent a confirmation email to <br />
               ${clientemailRef.current.value} <br />including your personal password details.
              </p>
              <!-- Close Button -->
              <button 
                id="closeButton" 
                style="background: transparent; color: #000; padding: 12px 40px; font-size: 13px; font-family:gothambold; border-radius: 6px; cursor: pointer; margin-top: 15px; border: 1px solid #E27808; outline: none;">
                Close
              </button>
            </div>
          `,
          showConfirmButton: false,
          allowOutsideClick: false,
          width: "500px",

          customClass: {
            popup: "custom-swal-container",
          },
          didOpen: () => {
            const closeButton = document.getElementById("closeButton");
            const customCloseButton =
              document.getElementById("customCloseButton");
            closeButton.addEventListener("click", () => {
              navigate(clientRoutes.login);
              window.location.reload();
              Swal.close();
            });
            customCloseButton.addEventListener("click", () => {
              Swal.close();
              navigate(clientRoutes.login);
            });
          },
        });
      } else {
        toast.error("Error submitting data");
      }
    } catch (error) {
      toast.error("Error submitting data");
      console.log("error", error);
    }
  };

  return (
    <div className={Styles.dashboard_main}>
      <ToastContainer />
      <div className={Styles.dashboard_flexmain}>
        <div className={Styles.flexdivider_2}>
          <div className={Styles.flexdivider_2_logo}>
            <img src={Img_logo} alt="admin_dash_logo" />
          </div>
          <div className={Styles.flexdivider_2_formcontainer}>
            <form autoComplete="">
              <div className={Styles.flexdivider_2_formcontainer_name}>
                <label className={Styles.label}>Name</label>
                <input
                  placeholder="Enter here"
                  required
                  type="text"
                  name="name"
                  ref={clientnameRef}
                  minLength={2}
                  maxLength={100}
                />
              </div>

              {/* Gender Selection */}
              <div className={Styles.flexdivider_2_formcontainer_name}>
                <label className={Styles.label}>Gender</label>
                <select
                  ref={clientgenderRef}
                  name="gender"
                  required
                  className={Styles.gender_select}
                >
                  <option value="">Choose from list</option>
                  <option value="MALE">Male</option>
                  <option value="FEMALE">Female</option>
                </select>
              </div>

              {/* DOB */}
              <label className={Styles.labelout}>DOB</label>
              <div className={Styles.flexdivider_2_formcontainer_dob}>
                <input
                  placeholder="dd"
                  id={Styles.firstdob}
                  required
                  type="text"
                  name="dob"
                  ref={clientdobdayRef}
                  minLength={1}
                  maxLength={2}
                />
                <input
                  placeholder="mm"
                  id={Styles.seconddob}
                  required
                  ref={clientdobmonthRef}
                  type="text"
                  name="dob"
                  minLength={1}
                  maxLength={2}
                />

                <input
                  placeholder="yyyy"
                  required
                  id={Styles.thriddob}
                  ref={clientdobyearRef}
                  type="text"
                  name="dob"
                  minLength={4}
                  maxLength={4}
                />
              </div>

              {/* DOB ENDS */}
              <div className={Styles.flexdivider_2_formcontainer_name}>
                <label className={Styles.label}>Email ID</label>
                <input
                  placeholder="Enter here"
                  required
                  type="email"
                  name="email"
                  ref={clientemailRef}
                  minLength={2}
                  maxLength={100}
                />
              </div>

              {/* <div className={Styles.flexdivider_2_formcontainer_name}>
                <label className={Styles.label}>Password</label>
                <input
                  placeholder="Enter here"
                  type="password"
                  name="password"
                  required
                  minLength={2}
                  maxLength={50}
                  ref={clientpasswordRef}
                />
              </div> */}

              <div className={Styles.flexdivider_2_formcontainer_name}>
                <label className={Styles.label}>Phone</label>
                <input
                  placeholder="Enter here"
                  required
                  type="number"
                  ref={clientphoneRef}
                  name="phone"
                  minLength={2}
                  maxLength={50}
                />
              </div>
              <br />
              <div className={Styles.reCaptchamain}>
                <ReCAPTCHA
                  sitekey={ApiEndpoints.sitekey}
                  onChange={handleCaptchaVerify}
                  ref={reCaptchaRef}
                  theme="dark"
                />
              </div>
              <br />
              <div className={Styles.flexdivider_2_formcontainer_button}>
                <button type="submit" onClick={handleSubmit}>
                  <span>Register</span>
                </button>
              </div>

              <div className={Styles.flexdivlogintext}>
                <p>
                  Already have an account?{" "}
                  <span>
                    <Link to={clientRoutes.login}>Login </Link>
                  </span>
                </p>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
